import React from "react";

import TickIcon from "images/icons/tick-dark.inline.svg";

const ProgramImpact = ({ programImpact }) => {
  return (
    <div className="flex items-center flex-col sm:flex-row sm:h-full">
      <div className="flex flex-col items-start flex-1 w-full gap-4 py-6 px-2">
        <div className="w-full">
          <h3
            className="lato-300-latin pb-2 not-italic font-normal planet:!text-gray-generic"
            dangerouslySetInnerHTML={{
              __html: programImpact.title
            }}
          />
        </div>
        {programImpact?.list?.map((impactItem, idx) => (
          <div className="flex justify-between sm:py-1" key={`impact_${idx}`}>
            <TickIcon className="w-5 h-5 stroke-black-lighter planet:stroke-gray-generic" />
            <div
              className="text-black-lighter planet:text-gray-generic text-sm md:text-base pl-2"
              dangerouslySetInnerHTML={{
                __html: impactItem.impact
              }}
            />
          </div>
        ))}
        ;
      </div>
    </div>
  );
};

export default ProgramImpact;
